import {
  BillingIntervalEnum,
  InternalBillingSource,
  TBillableProduct,
  TBillingItemInitialState,
  TBillingProductForCheckout,
} from '@commenda/types/src/billing/types';
import { TeamMemberCalendarLinks, TeamMembersEnum } from '@commenda/utils';
import { MeetingModel } from '@commenda/utils/models/meeting';
import {
  IndiaWizardBillingProductTags,
  USWizardBillingProductIds,
} from './productTags';

export const createBillingItem = (
  product: TBillingProductForCheckout,
  config: TBillingItemInitialState
): TBillableProduct => {
  const basePrice = product.netPrice.price;
  const quantity = Math.max(
    config?.minimumQuantity || 1,
    config?.quantity || 1
  );

  return {
    ...product,
    quantity,
    customizable: config?.customizable ?? true,
    minimumQuantity: config?.minimumQuantity,
    totalPriceBeforeDiscount: basePrice * quantity,
    totalPriceAfterDiscount: basePrice * quantity, // Apply any discounts here
  };
};

export const getTotalQuantity = (billingItems: TBillableProduct[]) =>
  billingItems.reduce((sum, item) => sum + item.quantity, 0);

export const billingPeriodDisplayNameMap: Record<BillingIntervalEnum, string> =
  {
    [BillingIntervalEnum.MONTH]: 'Monthly Subscription',
    [BillingIntervalEnum.SEMI_ANNUAL]: 'Semi-Annual Subscription',
    [BillingIntervalEnum.QUARTER]: 'Quarterly Subscription',
    [BillingIntervalEnum.YEAR]: 'Annual Subscription',
  };

export const productDescriptions = {
  baseProductBundleCount: 'Includes Virtual Address for 1 Year',
  [USWizardBillingProductIds.US_COMPLIANCE_PACKAGE]:
    'Includes BOI (Beneficial Ownership Information) Report Filing, Annual Report Filing, IRS (Internal Revenue Service) Tax Filing, Bookkeeping ',
  [IndiaWizardBillingProductTags.OVERSEAS_DIRECT_INVESTMENT]:
    'for Indian Tax Resident',
};

export const BookACallLinkByBillingSource = (
  billingSource: InternalBillingSource
): string => {
  switch (billingSource) {
    case InternalBillingSource.NEEDS_ASSESSMENT_CHECKOUT:
      return MeetingModel.MEETING_LINKS.INCORPORATION_WIZARD_BOOK_A_CALL;
    case InternalBillingSource.MARKETPLACE_SERVICE_CHECKOUT:
      return MeetingModel.MEETING_LINKS.HUBSPOT_BOOK_A_CALL_URL;
    default:
      return TeamMemberCalendarLinks[TeamMembersEnum.OPS_UPSELL];
  }
};

export * from './paymentStatusMessages';
